import { render, staticRenderFns } from "./PvTab.vue?vue&type=template&id=4b5650a0&"
import script from "./PvTab.vue?vue&type=script&lang=js&"
export * from "./PvTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports